import defaultHomePage from './default.json';
import homeBConfig from './home-b.json';
import homeRebuild from './home-rebuild.json';
import { resolveHomeCopyVariant } from './variants';
import { resolveVariant as resolveLandingVariant } from '../landingPages/variants';

/**
 * All home v2 JSON payloads keyed by slug (matches values in `homeCopyVariantRegistry`).
 * Add a new import + entry when shipping a copy experiment.
 *
 * Version A (default): all-in-one platform copy (home-b.json)
 * Version B (hc=b):    discipline/rules-focused copy (default.json)
 */
export const homePageConfigs = {
  default: defaultHomePage,
  'home-b': homeBConfig,
};

/**
 * Precision Desk home (`HomeTemplate` / sectionOrder) — primary `/home` payload.
 */
export const homeRebuildConfigs = {
  'home-rebuild': homeRebuild,
};

export const defaultHomeRebuildSlug = 'home-rebuild';

/**
 * Resolved config for the current marketing home (v2) template.
 * @param {string | null | undefined} variantTag - from URL `?hc=` (e.g. `default`, `1`, `b`)
 * @returns {typeof defaultHomePage}
 */
export function getHomePageConfigByVariant(variantTag) {
  const slug = resolveHomeCopyVariant(variantTag);
  const config = homePageConfigs[slug];
  return config || homePageConfigs.default;
}

/** Default copy when no `?hc=` is present (quiz, emails, etc.). */
export function getHomePageConfig() {
  return getHomePageConfigByVariant(null);
}

/**
 * Config for `/home` Precision Desk template (`?v=` maps via landingPages/variants → home-rebuild).
 * @param {string | null | undefined} variantTag
 */
export function getHomeRebuildConfigByVariant(variantTag) {
  const slug = resolveLandingVariant(variantTag);
  if (slug === 'landing-rebuild' || slug === 'home-rebuild') {
    return homeRebuildConfigs['home-rebuild'];
  }
  return homeRebuildConfigs[slug] || homeRebuildConfigs[defaultHomeRebuildSlug];
}

export default defaultHomePage;
